// OEM App 定制 — 定制申请审核：状态 / 依据 / 历史 mock
// TODO: 联调时替换为接口数据

// 项目级定制状态：待审核 / 进行中 / 已驳回（与资料 / UI / 构建状态正交）
export const AUDIT_STATUS = {
    pending: { key: 'pending', adminText: '待审核', adminColor: 'processing', companyText: '待平台审核', companyColor: 'processing' },
    approved: { key: 'approved', adminText: '进行中', adminColor: 'success', companyText: '进行中', companyColor: 'success' },
    rejected: { key: 'rejected', adminText: '已驳回', adminColor: 'error', companyText: '已驳回', companyColor: 'error' },
};

export const auditStatusInfo = (status) => AUDIT_STATUS[status] || AUDIT_STATUS.pending;
export const isAuditApproved = (status) => status === 'approved';

export const nowStr = () => new Date().toLocaleString('zh-CN', { hour12: false });

// 初始审核状态（未列出的项目默认「进行中」）
export const INITIAL_AUDIT_STATES = {
    'OEM-1010': {
        status: 'pending',
        history: [{ action: 'submit', text: '企业提交定制申请', operator: '企业客户', time: '2026-09-13 09:20' }],
    },
    'OEM-1011': {
        status: 'rejected',
        history: [
            { action: 'submit', text: '企业提交定制申请', operator: '企业客户', time: '2026-09-12 15:40' },
            { action: 'reject', text: '驳回：应用名称与营业执照主体不符，请核对后重新提交', operator: '平台客服', time: '2026-09-12 17:05' },
        ],
    },
};

export const DEFAULT_AUDIT_STATE = { status: 'approved', history: [] };
export const getAuditState = (states, id) => states[id] || DEFAULT_AUDIT_STATE;
